<form #f="ngForm" name="calcForm" [formGroup]="calcForm">

    <div *ngFor="let questionSegment of arhlCalcIn">
        <label class="mb-1 text-center d-block">
            <b>{{questionSegment['title']}}</b>
        </label>
        <div [formGroupName]="questionSegment['id']" *ngFor="let question of questionSegment['questions']">
            <div class="form-group mb-3" *ngIf="isVisible(question.id)">
                <label class="mb-1 ">
                    {{question.title}}
                </label>
                <ng-container *ngIf="question.type === 'dropdown'">

                    <select class="form-select rounded-0" [formControlName]="question.id">
                        <option value=""></option>
                        <option *ngFor="let option of question.options" [value]="option.id"
                            [selected]="isOptionSelected(questionSegment['id'], question.id,  option.id)">
                            {{option.title}}
                        </option>
                    </select>
                </ng-container>
                <ng-container *ngIf="question.type === 'button-switch'">
                    <div class="btn-group btn-group  btn_switch_group" data-toggle="buttons">
                        <label class="btn btn-secondary"
                            [ngClass]="{'active': isChecked(questionSegment['id'], question, option.id)}"
                            *ngFor="let option of question.options">
                            <input type="radio" class="btn-check" [name]="question.id" [formControlName]="question.id"
                                [id]="option.id" autocomplete="off" [value]="option.id"
                                [checked]="isChecked(questionSegment['id'], question, option.id)"
                                (click)="buttonSwitchClick(question, option, questionSegment['id'])"> {{option.title}}
                        </label>
                    </div>
                </ng-container>
                <ng-container *ngIf="question.type === 'number'">
                    <input type="number" [attr.min]="question?.validation?.min" [attr.max]="question?.validation?.max"
                        class="form-control " [formControlName]="question.id" />
                </ng-container>
                <ng-container *ngIf="question.type === 'switch'">

                    <div class="form-check form-switch iQswitch d-inline ms-3">
                        <input class="form-check-input float-none mt-2" type="checkbox" role="switch" [formControlName]="question.id"
                            id="flexSwitchCheckDefault">
                        <label class="form-check-label" for="flexSwitchCheckDefault">&nbsp;</label>
                    </div>
                </ng-container>
                <div *ngIf="hasError(questionSegment['id'], question.id)">
                    <div class="errors_block">{{question['errorMessage']}}</div>
                </div>
            </div>
        </div>
        <hr>
    </div>
</form>